
const { SimulationParameters } = require("./simulationParameters.js");
const { ResourcePool } = require("./resources/resourcePool.js");
const { ProjectPool } = require("./projects/projectPool.js");
const { StrategyManager } = require("./automation/strategyManager.js");
const { assignAllResources, handleEvent } = require("./automation/automator.js");
const { PerformanceTracker } = require("./metrics/performanceTracker.js");

class Simulator {
    constructor(parameterDict, projectData) {
        this.hoursPassed = 0;
        this.passedEvents = [];
        this.setupInitialEnvironment(parameterDict, projectData);

        this.automationMethod = null;
        this.currState = "initial";

        this.finishedTasks = [];
    }

    getData(){
        return {projects: this.projectPool.getData(), hoursPassed: this.hoursPassed, futureLoadMultiplier: this.params.futureLoadMultiplier};
    }

    setupInitialEnvironment(parameterDict, projectData) {
        this.params = new SimulationParameters(parameterDict);
        this.resourcePool = new ResourcePool(this);
        this.projectPool = new ProjectPool(this, projectData);
        this.performanceTracker = new PerformanceTracker(this);
    }

    //Calculate the new efficiency factor as specified
    calculateWorkDelay() {
        //Get the amount of delayed projects
        var delayedProjectsAmount = 0;
        this.projectPool.projects.forEach(currProject => {
            if (currProject.isDelayed()) {
                delayedProjectsAmount += 1;
            }
        })

        const workAmount = (1 - this.params.delayPerProjectFraction) ** delayedProjectsAmount;
        return workAmount;
    }

    isSimulationFinished() {
        if (this.params.spawnProjectRate == null && this.projectPool.allProjectsFinished()) {
            this.currState = "allProjectsFinished";
            return true
        }
        
        if (this.hoursPassed >= this.params.simulationMaxDurationHours) {
            this.currState = "simulationFinished";
            return true
        }

        return false
    }

    automateUntilEnd(automationMethod, events) {
        var eventDict = this.eventsListToDict(events);
        this.automationMethod = automationMethod;
        var finishedSimulation = false;

        while (!finishedSimulation) {
            this.handleAllNewEvents(eventDict[this.hoursPassed]);
            finishedSimulation = this.automateOneStep(eventDict);
        }
    }

    eventsListToDict(events) {
        var eventDict = {};

        for (var i = 0; i <= this.params.simulationMaxDurationHours; i++) {
            eventDict[i] = [];
        }

        events.forEach(currEvent => {
            eventDict[currEvent.hour].push(currEvent);
        })

        return eventDict;
    }

    handleAllNewEvents(currEvents) {
        var passedEventsCurrTime = this.eventsListToDict(this.passedEvents)[this.hoursPassed];
        var passedEventsCurrTimeJSON = passedEventsCurrTime.map(x => JSON.stringify(x));

        currEvents.forEach(currEvent => {

            //Ignore the events which are already in the passed, since we sent those to the server after handling them locally
            const currEventJSON = JSON.stringify(currEvent);
            if (!passedEventsCurrTimeJSON.includes(currEventJSON)){
                handleEvent(currEvent, this)
            }

        })
    }



    automateOneStepWithEventStack(eventDict) {
        if(this.isSimulationFinished()){
            return true;
        }

        const currEvents = eventDict[this.hoursPassed];

        currEvents.forEach(currEvent => {
            handleAssignEvent(currEvent, this)
        })

        this.simulateOneStep();
    }

    automateOneStep() {
        if(this.isSimulationFinished()){
            return true;
        }

        if (this.automationMethod != null && this.automationMethod != "precalculated") {
            const priorityAssigner = StrategyManager.getStrategyHandler(this.automationMethod);
            const priorityTasks = priorityAssigner(this);
            assignAllResources(priorityTasks, this);
        }

        this.simulateOneStep();

        return false
    }

    simulateOneStep() {

        this.resourcePool.getAllResources().forEach(currResource => {
            currResource.outputPastHour = 0;
            currResource.workPastHour = 0;
            currResource.lastResourceWorked = null;
        })

        this.hoursPassed += 1;

        var resourceFinished = false;

        const workAmount = this.calculateWorkDelay()

        //Update the training/hiring/firing
        this.resourcePool.updateHours();

        //Update all the positions in order, if they are not being worked on / are finished
        this.projectPool.projects.forEach(currProject => {

            if (currProject.startHour + currProject.leadTimeHours < this.hoursPassed) {
                currProject.delay += 1;
            }

            currProject.taskArray.forEach(currTask => {
                //Gray resources are outsourced an work without delay
                if (currTask.resourceGroupID == "G" && currTask.isReadyToStart()) {
                    return;
                }

                //Task isnt being worked on
                if (currTask.currentResource == null && !currTask.isFinished() && currTask.isReadyToStart() && currProject.startHour < this.hoursPassed) {
                    currTask.startHour += 1;
                }
                ///Task is being worked on, but there might be possible delay in the workamount
                if (currTask.currentResource != null) {
                    currTask.startHour += 1 - workAmount
                }
            })
        });

        //Move all the tasks as far as possible to the left
        this.projectPool.projects.forEach(currProject => {
            currProject.shiftAllTasks(this.hoursPassed);
        })

        //Also work on the outsourced tasks
        this.projectPool.projects.forEach(currProject => {
            currProject.taskArray.forEach(currTask => {
                if (currTask.resourceGroupID == "G" && !currTask.isFinished() && currTask.isReadyToStart()) {
                    currTask.performWork(1);
                }
            })
        });

        var resources = this.resourcePool.getAllResources();
        //Update the internal simulation state (Do this afterwards to prevent issues with visualisation when a task finishes)
        resources.forEach(currResource => {
            resourceFinished |= currResource.workOnTask(workAmount);
        });

        this.projectPool.spawnProjectIfReady();

        //Update the current state
        if(!this.isSimulationFinished()){
            this.currState = "simulating";
        }

        //Store the metrics
        this.performanceTracker.storeMetrics();

        return resourceFinished;
    }
}


module.exports = { Simulator };
